export default __webpack_public_path__ + "static/media/female_pink.83f20dac.svg";